/**
 * Created by casteloyee on 2017/7/15.
 */
import React, { Component } from 'react';
import { Input, Modal, Button, Select, message, Row, Col, Radio } from 'antd';
import API_URL from '../../common/url';

const Option = Select.Option;
const RadioGroup = Radio.Group;

class AddModuleDefine extends Component {

    constructor(props) {
        super(props);
        const criteriaDataType = props.criteriaDataType ? props.criteriaDataType : 'TEXT';
        const formatValue = props.formatValue ? props.formatValue : criteriaDataType == 'DATE' ? 'YYYY-MM-DD' : '0';
        this.state = {
            visible: false,
            confirmLoading: false,
            moduleDefineId: 0,
            moduleDefineName: props.moduleDefineName ? props.moduleDefineName : '',
            moduleDefineCode: props.moduleDefineCode ? props.moduleDefineCode : '',
            criteriaDataType,
            projectDefineWebType: props.projectDefineWebType ? props.projectDefineWebType : 'INPUT',
            moduleDefineIsRequired: props.moduleDefineIsRequired ? props.moduleDefineIsRequired : '0',
            formatValue,
        };
    }

    show = (dataItem, mongo) => {
        if (dataItem){
            const criteriaDataType = dataItem.criteriaDataType ? dataItem.criteriaDataType : 'TEXT';
            let formatValue = dataItem.formatValue ? dataItem.formatValue : criteriaDataType == 'DATE' ? 'YYYY-MM-DD' : '0';
            if (criteriaDataType == 'NUMBER' && formatValue){
                if (formatValue == "9999.9"){
                    formatValue = 1;
                } else if (formatValue == "9999.99"){
                    formatValue = 2;
                } else {
                    formatValue = 0;
                }
            }
            this.setState({
                moduleDefineName: dataItem.moduleDefineName ? dataItem.moduleDefineName : '',
                moduleDefineCode: dataItem.moduleDefineCode ? dataItem.moduleDefineCode : '',
                criteriaDataType,
                projectDefineWebType: dataItem.projectDefineWebType ? dataItem.projectDefineWebType : 'INPUT',
                moduleDefineIsRequired: dataItem.moduleDefineIsRequired ? dataItem.moduleDefineIsRequired : '0',
                formatValue,
                visible: true,
                moduleDefineId: mongo == 1 ? dataItem.moduleDefineId : dataItem.investigationExecuteDefineId,
            });
        } else {
            this.setState({
                visible: true,
                moduleDefineName: '',
                criteriaDataType: 'TEXT',
                projectDefineWebType: 'INPUT',
                moduleDefineIsRequired: '1',
                formatValue: '',
                moduleDefineId: 0,
            });
        }
    };

    hide = () => {
        this.setState({
            visible: false,
        });
    };

    inputModuleDefineName = e => {
        this.setState({
            moduleDefineName: e.target.value,
        });
    };

    handleSelectDataType = value => {
        this.setState({
            criteriaDataType: value,
            projectDefineWebType: 'INPUT',
        });
        if (value == 'DATE'){
            this.setState({
                formatValue: 'YYYY-MM-DD',
            });
        } else if (value == 'NUMBER'){
            this.setState({
                formatValue: '0',
            });
        }
    };

    handleSelectWebType = value => {
        this.setState({
            projectDefineWebType: value,
        });
    };

    handleSelectFormatValue = value => {
        this.setState({
            formatValue: value,
        });
    };

    onSelectRequire = e => {
        this.setState({
            moduleDefineIsRequired: e.target.value,
        });
    };

    getWebTypeOptions = () => {
        const {criteriaDataType, projectDefineWebType, formatValue} = this.state;
        if ("TEXT" == criteriaDataType) {
            return (
                <li className="modal-item" style={{paddingBottom: 20}}>
                    <div className="item-left" style={{width: 86, paddingRight: 10}}>填写方式:</div>
                    <div className="item-right">
                        <Select value={projectDefineWebType} style={{ width: 180, marginLeft: 10 }} onChange={this.handleSelectWebType}>
                            <Option key='INPUT'>文本框</Option>
                            <Option key='RADIO'>单选</Option>
                            <Option key='CHECKBOX'>多选</Option>
                            <Option key='SELECT'>下拉框</Option>
                            <Option key='TEXTAREA'>文本域</Option>
                        </Select>
                    </div>
                </li>
            );
        }
        if ("NUMBER" == criteriaDataType) {
            return (
                <li className="modal-item" style={{paddingBottom: 20}}>
                    <div className="item-left" style={{width: 86, paddingRight: 10}}>小数位数:</div>
                    <div className="item-right">
                        <Select value={formatValue} style={{ width: 180, marginLeft: 10 }} onChange={this.handleSelectFormatValue}>
                            <Option key={'0'}>0</Option>
                            <Option key={'1'}>1</Option>
                            <Option key={'2'}>2</Option>
                        </Select>
                    </div>
                </li>
            );
        }
        if ("DATE" == criteriaDataType) {
            return (
                <li className="modal-item" style={{paddingBottom: 20}}>
                    <div className="item-left" style={{width: 86, paddingRight: 10}}>日期格式:</div>
                    <div className="item-right">
                        <Select value={formatValue} style={{ width: 180, marginLeft: 10 }} onChange={this.handleSelectFormatValue}>
                            <Option key='YYYY-MM-DD'>时间控件(年月日)</Option>
                            <Option key='YYYY-MM'>时间控件(年月)</Option>
                            <Option key='YYYY-MM-DD HH:MI'>时间控件(年月日时分)</Option>
                        </Select>
                    </div>
                </li>
            );
        }
    }

    componentDidMount() {
    }

    // 提交表单
    handleSubmit = () => {
        const value = {
            moduleDefineId: this.state.moduleDefineId,
            moduleDefineName: this.state.moduleDefineName.replace(/\s+/g, ""),
            criteriaDataType: this.state.criteriaDataType,
            moduleDefineCode: this.state.moduleDefineCode,
            projectDefineWebType: this.state.criteriaDataType == 'DATE' ? 'DATETIMEPICKER' : this.state.projectDefineWebType,
            moduleDefineIsRequired: this.state.moduleDefineIsRequired,
            formatValue: this.state.formatValue,
        };
        this.props.handleModuleDefineAction(value);
        this.setState({
            visible: false,
        });
    };

    render() {
        const { visible,confirmLoading, moduleDefineName,criteriaDataType,moduleDefineIsRequired, moduleDefineId } = this.state;
        return (
            <Modal
                title={moduleDefineId > 0 ? '修改字段' : '添加字段'}
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                width="400px"
                confirmLoading={confirmLoading}
            >
                <div className="modal-content" style={{ padding: 0 }}>
                    <ul className="modal-list">
                        <li className="modal-item" style={{paddingBottom: 20}}>
                            <div className="item-left" style={{width: 86, paddingRight: 10}}>字段名称:</div>
                            <div className="item-right">
                                <Input style={{ width: 180, marginLeft: 10 }} value={moduleDefineName} onChange={this.inputModuleDefineName} />
                            </div>
                        </li>
                        <li className="modal-item" style={{paddingBottom: 20}}>
                            <div className="item-left" style={{width: 86, paddingRight: 10}}>字段类型:</div>
                            <div className="item-right">
                                <Select disabled={moduleDefineId > 0} value={criteriaDataType} style={{ width: 180, marginLeft: 10 }} onChange={this.handleSelectDataType}>
                                    <Option value="TEXT">文本型</Option>
                                    <Option value="DATE">时间型</Option>
                                    <Option value="NUMBER">数值型</Option>
                                </Select>
                            </div>
                        </li>
                        {this.getWebTypeOptions()}
                        <li className="modal-item" style={{paddingBottom: 20}}>
                            <div className="item-left" style={{width: 86, paddingRight: 10}}>是否必填:</div>
                            <div className="item-right">
                                <RadioGroup style={{ marginLeft: 10 }} onChange={this.onSelectRequire} value={moduleDefineIsRequired}>
                                    <Radio value={'1'}>是</Radio>
                                    <Radio value={'0'}>否</Radio>
                                </RadioGroup>
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        );
    }
}

export default AddModuleDefine;



// WEBPACK FOOTER //
// ./src/components/executeMgr/AddModuleDefine.js